import {Map,Set, Iterator } from 'core-js/es6'
import $ from 'jquery';
//import Papa from 'papaparse'; 
//import { Config, dummyText } from './ViewportConfig';
import {
  ViewportScrollInformations,
  Relationship, RelationshipWithId, SectionRelationship,
  ProductSection, Product, Language, ProductVersion, ProductStructur, SpaceProperty
} from "./ProductModels";
import { ProductViewport, PartProductOverviewport, Viewport } from './Viewport';
import {spaceKeys} from '@/softbooks/ManualsSoftbook';

export class UtilService {


  //public static readonly CSV_NAVIGATION_DATA: string =  'http://sheep.abg.fsc.net:8090/download/attachments/2755833/navigation.csv?api=v2';
  public static readonly LINE_SEPARATOR: string = ';';

  private static ALL_PROD_VERSIONS: ProductVersion[] = [];
  
  public productStructur:ProductStructur;
  //public readonly viewportScrollInformations:ViewportScrollInformations;




  PRODUCT_SECTIONS: ProductSection[] = [];
  ALL_PRODUCTS: Product[] = [];

  LIMITED_PRODUCT_MAP: Map<string,Product> = new Map<string,Product>();
  SECTION_MAP: Map<string, ProductSection> = new Map<string, ProductSection>();
  SUBSECTION_MAP: Map<string, ProductSection> = new Map<string, ProductSection>();
  SECT_TO_SUBSECT_MAP: Map<string, Set<string>> = new Map<string, Set<string>>();
  SUBSECT_TO_PRODUCT_MAP: Map<string, Set<string>> = new Map<string, Set<string>>();
  PRODUCT_ALPHABETICAL: Map<string, Set<Product>> = new Map<string, Set<Product>>();
  PRODUCT_TO_VERSION_GERMAN:Map<string,ProductVersion[]>  = new Map<string, ProductVersion[]>();
  PRODUCT_TO_VERSION_ENGLISH:Map<string,ProductVersion[]> = new Map<string, ProductVersion[]>();
  

  constructor(public lang: Language, public viewportScrollInformations:ViewportScrollInformations) {
  }


  public loadDatas(langString:string){
    return $.ajax({
      //url: 'http://localhost:8080/confluence/rest/fjadmintools/1.0/manuals/getStructure?language=de',
      url: process.env.VUE_APP_BASE_URL+'/rest/fjadmintools/1.0/manuals/getStructure?language='+langString,
      method: "GET"
      /*,username:"username",
      password:"password"
      */
    })
      .done(response => {
       // console.log('Gone well fetching..');
       // console.dir(response);
        this.productStructur = response;
      })
      .fail(xhr => {
        throw new Error('An error occured while getting productstructure ' + xhr);
      });
  }



  public generateProdVersionsDatas(prodVersionData:any[]):void{
    
  }

  public loadProductVersionsDatas(viewport:ProductViewport) {
    return $.ajax({
      url: process.env.VUE_APP_BASE_URL+'/rest/fjadmintools/1.0/manuals/getStructure?language='+Language[viewport.viewportLanguage],
      method: "GET"
    })

  }


  getProductFromName(productName:string):Product{
  return this.LIMITED_PRODUCT_MAP.get(productName);
  }

}

export function getURLParameter(param): string {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === param) {
      return sParameterName[1] == null ? true : sParameterName[1];
    }
  }
}


export function simplifyProdName(name:string ):string{

let simpliedName:string = name.toLowerCase().trim().replace(/[^a-zA-Z0-9]/g, '');

return simpliedName;

}


export function getVersionsOfProductAndSetInformations(productViewport:ProductViewport, spaceProperty:SpaceProperty, lang:Language): ProductVersion[] {
  let utilService = productViewport.utilserv;

  let servicePacks:any[] = utilService.productStructur.servicePacks;

  if(spaceProperty.spaceType==="SERVICE_PACK"){
    //console.log("Viewport Detected as Service Pack");
    
    let prodVersionsForServicePack:Array<ProductVersion> = new Array<ProductVersion>();

    for( let [index, sp] of servicePacks.entries()){
      let tmp:ProductVersion = {
        productName:sp.name,
        productId:sp.id,
        latest:index===0?true:false,
        spaceKey:sp.spaceKey,
        spaceUrl:sp.spaceUrl,
        version:sp.name,
        productPackage:false,
        isCurrentVersion:sp.spaceKey===productViewport.spaceKey?true:false
      }
      
      prodVersionsForServicePack.push(tmp);

      if(tmp.isCurrentVersion){
        productViewport.currentVersion = tmp;
      }

      if(!tmp.isCurrentVersion){ 
        //We add the version to viewport.prodVersionsWithoutCurrentVersion
        productViewport.prodVersionsWithoutCurrentVersion.push(tmp);
      }

      //console.dir("GET-VERSION SERVICE-PACK   ",tmp);
    }
     
    return prodVersionsForServicePack;
  }

  else if (spaceProperty.prodId==null) {
    console.error('Cannot get versions of empty product');
    return new Array<ProductVersion>();
  }
  
  let productVersions: ProductVersion[] = utilService.productStructur.products[spaceProperty.prodId].versions;
  
  if(!productVersions){
    console.error("Cannot retrieve versions of: "+spaceProperty.prodId);
    return null;
  }

  //Setting product Name and Package type for each Productversion 

  for(let vers of productVersions)
  {
    vers.productName = utilService.productStructur.products[spaceProperty.prodId].name;
    vers.productPackage = utilService.productStructur.products[spaceProperty.prodId].productPackage;
    //We set the latest Version of this product
    if(vers.latest)
    {
       productViewport.latestVersion = vers;
    }

    //We set the current(active) Version of this product

    if(vers.spaceKey === productViewport.spaceKey){
      productViewport.currentVersion = vers;
    }
    else{
      //We add the version to viewport.prodVersionsWithoutCurrentVersion
      productViewport.prodVersionsWithoutCurrentVersion.push(vers);
    }
  }

  return productVersions;
}


//@In use

export function getVersionUrl(version:ProductVersion,viewport:Viewport): string {
  if (version == null) {
    throw new Error(`Product is null`);
  }


  var prodUrl: string = '';

  prodUrl += `${viewport.viewportScrollInformations.contextPath}/${version.spaceUrl}`;

  return prodUrl;
}

 
export function populateProductSpace(
  prod_viewport: ProductViewport):Viewport {

    prod_viewport.allProductVersions = getVersionsOfProductAndSetInformations(prod_viewport,
      prod_viewport.spaceProperty,
      prod_viewport.viewportLanguage);
      
      if (!prod_viewport.allProductVersions || prod_viewport.allProductVersions.length <= 0) {

        if(prod_viewport.spaceProperty.spaceType==='PRODUCT' || prod_viewport.spaceProperty.spaceType==='PRODUCT_PACKAGE')
        {
          throw new Error('Every Product must have at least one version:'+prod_viewport.spaceProperty.prod);
        }
        /*else if(prod_viewport.spaceProperty.spaceType==='PRODUCT'){
 
        }
        */
      }

  return prod_viewport;
}

export function populatePartProductOverviewSpace(spaceKey: string,
  prodName: string, lang: Language,
  partProdOver_viewport: PartProductOverviewport) {

  $.ajax({
    url:'',
    method: "GET"
  })
    .then(response => {
      let res:any;
      return res;
    })
    .then(gepars => {

      partProdOver_viewport.setPartViewportDatas(gepars);
      partProdOver_viewport.setVersionsDatas();

      //console.dir(partProdOver_viewport);
      
    })
    .fail(xhr => {
      throw new Error('CSV read Error NEW_VERSION: ' + xhr);
    });   
}


export function getLanguageDisplayString(currentLang: Language, langToDisplay: Language): string {
  switch (currentLang) {
    case Language.DE:
      break;

    case Language.EN:
      break;

    default:
      return null;

  }
}


function getAllProducts(productStructur:any):Product[]{
  return <Product[]>Object.values(productStructur.products)
 }
 
 function setProdName(products:Product[]):Product[]{
     for(let prod of products){
       prod.versions.forEach((prodVersion) =>{
         prodVersion.productName = prod.name;
       });
     }
     return products;
   }

   
 function setAttributesFromProduct(products:Product[]):Product[]{
  for(let prod of products){
    prod.versions.forEach((prodVersion) =>{
      prodVersion.productName = prod.name;
      prodVersion.productId=prod.id;
      prodVersion.productPackage=prod.productPackage;
    });
  }
  return products;
}

 
 
 
 export function getAllProductVersions(productStructure:any):ProductVersion[]{
     let allProducts:Product[] = getAllProducts(productStructure);

     allProducts = setAttributesFromProduct(allProducts);

 
     let allProdVersion:ProductVersion[] = [];
 
     for(let singleProd of allProducts){
         allProdVersion = allProdVersion.concat(singleProd.versions);
        }
    
        return allProdVersion;
 }


 
 export function loadsearchData(searchText:string, langString:string){
  return $.ajax({
    url: process.env.VUE_APP_BASE_URL+'/rest/fjadmintools/1.0/manuals/searchManuals?language='+langString+'&searchText='+searchText,
    method: "GET"

  })
}


export function loadsearchDataForSoftbook(searchText:string, langString:string){
let spaKey = JSON.parse(spaceKeys);
let foundManuals = [];



//console.log(Object.entries(spaKey).length);


for(let sKey of Object.entries(spaKey)){

  //console.log(sKey);
  let spaceKey = sKey[0];

  let manualStuff:any = sKey[1];

  //console.log("VOICI CA: ", manualStuff);

  let manuals:Array<any> = manualStuff.manuals;


  if(!manuals)
    continue;
  

  for(let manual of manuals){
    
    //console.log('Title in Arbeit: ',manual['title']);
      if(manual['title'].toLowerCase().includes(searchText.toLowerCase()) )
      {
      //  console.log('Title gefunden: ',manual['title']);
        foundManuals.push(
          {
            productName:manualStuff.spaceProperties.prod,
            productId:manualStuff.spaceProperties.prodId, 
            language:manualStuff.spaceProperties.lang, 
            productVersion:manual.version, 
            url:spaceKey, 
            title:manual.title, 
            subtitle:manual.subtitle, 
            type:manual.type
          }
        );
      }   
      else{
        if(manual['subtitle'].toLowerCase().includes(searchText.toLowerCase()) )
        {
          //console.log('Sub-Title gefunden: ',manual['subtitle']);
          foundManuals.push(
            {
              productName:manualStuff.spaceProperties.prod,
              productId:manualStuff.spaceProperties.prodId, 
              language:manualStuff.spaceProperties.lang, 
              productVersion:manual.version, 
              url:spaceKey, 
              title:manual.title, 
              subtitle:manual.subtitle, 
              type:manual.type
            });
        } 
      }
  } 

  let lowerSubtitle = sKey[1];

 // console.log("Do it", lowerSubtitle + lowerTitle);

}


 let result:{language:string,
   searchText:string,
    foundProducts:{
      
    },
    foundManuals:{

    }};

    return foundManuals;


}


if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

 




